module.exports = __webpack_public_path__ + "img/slide-1__md.d2a776a5.jpg";